import { useStore } from '@/store/store';
import { getTradeMessages } from './messages/trade';
import { getStakingMessages } from './messages/staking';
import { getMyPageMessages } from './messages/mypage';
import { getOnetimePasscodeMessages } from './messages/one_time_passcode';
export const useMessage = () => {
    const store = useStore();
    const format = (object) => {
        var _a;
        const lang = store.state.userSettings.language || 'English';
        return ((_a = object === null || object === void 0 ? void 0 : object.find((m) => m.language === lang)) === null || _a === void 0 ? void 0 : _a.message) || '';
    };
    // TABS
    const HEADER_TABS = {
        STAKING: [
            { message: 'Staking', language: 'English' },
            { message: 'ステーキング', language: 'Japanese' },
            { message: '質押', language: 'Traditional' },
            { message: '质押', language: 'Simplified' },
        ],
        TRADE: [
            { message: 'Trade', language: 'English' },
            { message: 'トレード', language: 'Japanese' },
            { message: '交易', language: 'Traditional' },
            { message: '交易', language: 'Simplified' },
        ],
        HISTORY: [
            { message: 'Trade History', language: 'English' },
            { message: '取引履歴', language: 'Japanese' },
            { message: '交易紀錄', language: 'Traditional' },
            { message: '交易纪录', language: 'Simplified' },
        ],
        MYPAGE: [
            { message: 'MyPage', language: 'English' },
            { message: 'マイページ', language: 'Japanese' },
            { message: 'MyPage', language: 'Traditional' },
            { message: 'MyPage', language: 'Simplified' },
        ],
    };
    const tradeMessages = getTradeMessages();
    const stakingMessages = getStakingMessages();
    const mypageMessages = getMyPageMessages();
    const ontimePasscodeMessages = getOnetimePasscodeMessages();
    return Object.assign(Object.assign(Object.assign(Object.assign({ format,
        HEADER_TABS }, tradeMessages), stakingMessages), mypageMessages), ontimePasscodeMessages);
};
